// Sentry initialization should be imported first: https://docs.sentry.io/platforms/javascript/guides/react/#configure
import "@src/sentry-init";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "@src/index.css";
import { store } from "@store/store";
import { RouterProvider } from "react-router-dom";
import { router } from "@router/router";
import { AuthProvider } from "@context-providers/auth/auth-provider";
import { LoadingSpinnerProvider } from "@context-providers/loading-spinner-provider";
import { ErrorBoundary } from "@context-providers/error-boundary/error-boundary";
import { ToastProvider } from "@context-providers/toast/toast-provider";
import { NetworkConnectionProvider } from "@context-providers/network-connection/network-connection-provider";
import { CookieManagerLoader } from "@hooks/cookie-manager-loader";
// CssBaseline needs to be imported before all other styles to avoid errors
import { CssBaseline, ThemeProvider } from "@mui/material";
import { mainTheme } from "@styles/themes";
import { LocalizeLoader } from "@loaders/localize-loader";

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <Provider store={store}>
      <CookieManagerLoader>
        <LocalizeLoader>
          <CssBaseline />
          <ThemeProvider theme={mainTheme}>
            <ToastProvider>
              <NetworkConnectionProvider>
                <ErrorBoundary>
                  <LoadingSpinnerProvider>
                    <AuthProvider>
                      <RouterProvider
                        router={router}
                        future={{
                          // eslint-disable-next-line @typescript-eslint/naming-convention
                          v7_startTransition: true,
                        }}
                      />
                    </AuthProvider>
                  </LoadingSpinnerProvider>
                </ErrorBoundary>
              </NetworkConnectionProvider>
            </ToastProvider>
          </ThemeProvider>
        </LocalizeLoader>
      </CookieManagerLoader>
    </Provider>
  </StrictMode>
);
